import { render, staticRenderFns } from "./ReleaseButtons.vue?vue&type=template&id=50724120&scoped=true"
import script from "./ReleaseButtons.vue?vue&type=script&lang=ts"
export * from "./ReleaseButtons.vue?vue&type=script&lang=ts"
import style0 from "./ReleaseButtons.vue?vue&type=style&index=0&id=50724120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50724120",
  null
  
)

export default component.exports